var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, persistent: "" },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("Title", { attrs: { title: _vm.titleText, underlined: "" } })
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: _vm.close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                { attrs: { primary: "" }, on: { click: _vm.handleSave } },
                [_vm._v(" Salvar ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "simulator-edit-notes d-flex flex-column az-gap" },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "az-text-small mb-2" }, [
                _vm._v(" Recomendação ")
              ]),
              _c("v-select", {
                staticClass: "new-ux",
                attrs: {
                  items: _vm.recomendacaoOptions,
                  outlined: "",
                  dense: "",
                  "hide-details": "",
                  clearable: "",
                  placeholder: "Selecione..."
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function(ref) {
                      var selectedOption = ref.item
                      return [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              "x-small": "",
                              color:
                                _vm.recomendacaoColors[selectedOption.value] ||
                                "grey",
                              dark: ""
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.recomendacaoLabels[
                                    selectedOption.value
                                  ] || selectedOption.text
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.recomendacaoValue,
                  callback: function($$v) {
                    _vm.recomendacaoValue = $$v
                  },
                  expression: "recomendacaoValue"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c("div", { staticClass: "az-text-small mb-2" }, [
                _vm._v(" Setor ")
              ]),
              _c("input-by-type", {
                staticClass: "new-ux",
                attrs: { type: "text", outlined: "", "hide-details": "" },
                model: {
                  value: _vm.setorText,
                  callback: function($$v) {
                    _vm.setorText = $$v
                  },
                  expression: "setorText"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "simulator-edit-notes__tags" },
            [
              _c("div", { staticClass: "az-text-small mb-2" }, [
                _vm._v(" Tags ")
              ]),
              _c("ClientTags", {
                attrs: { tags: _vm.tagsList, canEdit: "", showTextNoTag: "" },
                on: {
                  "add-tag": _vm.handleAddTag,
                  "remove-tag": _vm.handleRemoveTag
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "simulator-edit-notes__description" },
            [
              _c("div", { staticClass: "az-text-small mb-2" }, [
                _vm._v(" Comentário ")
              ]),
              _c("input-by-type", {
                staticClass: "new-ux",
                attrs: { type: "textarea", outlined: "", "hide-details": "" },
                model: {
                  value: _vm.commentText,
                  callback: function($$v) {
                    _vm.commentText = $$v
                  },
                  expression: "commentText"
                }
              })
            ],
            1
          )
        ]
      ),
      _c("v-divider", { staticClass: "mt-2" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }